import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BrokenImageLinkTest } from '../../../components/BrokenImageLinkTest';
import { Hyperlink } from '../../../components/Hyperlink';
import { fetchProfessionalInfos } from '../../../lawyer/lawyer.api';
import styles from './nav_lawyer_profile.module.scss';

type Props = {
  pictureUrl: string | null;
  href: string;
  name: string;
};

type State = {
  firstname: string;
  lastname: string;
  loading: boolean;
};

export class NavLawyerProfile extends React.Component<Props, State> {
  state: State = {
    firstname: '',
    lastname: '',
    loading: true,
  };

  isMounted: boolean = false;

  async componentDidMount() {
    this.isMounted = true;
    const { name } = this.props;
    if (!name) {
      try {
        const { firstname, lastname } = await fetchProfessionalInfos();
        if (this.isMounted) {
          this.setState({ firstname, lastname, loading: false });
        }
      } catch (err) {
        throw err;
      }
    } else if (name && this.isMounted) {
      this.setState({
        firstname: name,
        lastname: '',
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  render() {
    const { href, pictureUrl } = this.props;
    const { firstname, lastname, loading } = this.state;
    const lawyerName = `${firstname} ${lastname}`;

    return (
      <Hyperlink href={href} className={styles.container}>
        <BrokenImageLinkTest url={pictureUrl}>
          {(isImageLinkBroken: boolean) => (
            <img
              className={styles.picture}
              src={
                pictureUrl && !isImageLinkBroken
                  ? pictureUrl
                  : '/img/user/user_icon.png'
              }
              alt={lawyerName}
            />
          )}
        </BrokenImageLinkTest>
        <div className={styles.name}>
          {!loading ? (
            <div className={styles.title} data-test-id="nav-user-name">
              {lawyerName}
            </div>
          ) : (
            <div className={styles.placeholder}>
              <div className={styles.animatedBackground} />
              <div
                className={classNames(
                  styles.backgroundMasker,
                  styles.nameSeparator,
                )}
              />
            </div>
          )}
          <div className={styles.subtitle}>
            <FormattedMessage id="navigation/user/components/NavLawyerProfile.tsx/1" />
          </div>
        </div>
      </Hyperlink>
    );
  }
}
